<ion-fab slot="fixed" vertical="bottom" horizontal="end">
  <ion-fab-button 
    (click)="openWhatsapp()" 
    style="box-shadow: none; background: none; padding: 0; -webkit-tap-highlight-color: transparent;">
    <ion-icon 
      name="logo-whatsapp" 
      style="font-size: 28px; -webkit-tap-highlight-color: transparent;">
    </ion-icon>
  </ion-fab-button>
</ion-fab>
<div class="repse-label repse-blue">
  Certificados en REPSE
</div>